import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Inner,
  Spinner,
  Text,
} from "./styles/analytics-widget-loading-styles";
import spinner from "./img/loading.gif";

const AnalyticsWidgetLoading = ({ active, text }) => (
  <Wrapper className={`animated ${active ? "fadeIn" : "fadeOut"}`}>
    <Inner>
      <Spinner
        src={spinner}
        alt="Loading spinner"
        data-test-id="loading-widget-spinner"
      />
      {text && <Text>{text}</Text>}
    </Inner>
  </Wrapper>
);

AnalyticsWidgetLoading.propTypes = {
  text: PropTypes.string,
  active: PropTypes.bool,
};

AnalyticsWidgetLoading.defaultProps = {
  text: PropTypes.isNull,
  active: PropTypes.isNull,
};

export default AnalyticsWidgetLoading;
